export default __webpack_public_path__ + "static/media/white-transit.cb66b718.svg";